import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white shadow-modal rounded-xl h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center justify-center text-center w-1/2 m-auto text-wrh-gray-dark t-18r min-h-md"
}
const _hoisted_3 = {
  key: 1,
  class: "h-full wrh-scroll"
}
const _hoisted_4 = {
  key: 2,
  class: "h-full"
}

import {
  ref, onMounted, toRefs,
} from 'vue';
import { useStore } from 'vuex';
import { getAuth } from 'firebase/auth';
import { useRouter } from 'vue-router';
import { Document } from '@/models';
import DocumentsList from './components/DocumentsList.vue';
import DocumentView from './components/DocumentView.vue';
import { getDocumentsData, downloadDocument, viewDocument } from './services/service';
import { noDocumentsMessage } from '@/constants';
import { showLoader } from '@/util/funcs';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();
const documents = ref<Document[]>([]);
const document = ref();
const showMessage = ref(false);
const viewPoint = ref(false);
const page = ref(1);
const totalRecords = ref(15);
const documentPDFUrl = ref('');
const totalDocuments = ref(0);
const showDocumentSkeleton = ref(false);
const showViewSkeleton = ref(false);

const download = async (event:Document) => {
  showLoader(true);
  await downloadDocument(event);
  showLoader(false);
};

const view = async (event:Document) => {
  showViewSkeleton.value = true;
  document.value = event;
  viewPoint.value = true;
  documentPDFUrl.value = await viewDocument(event);
  showViewSkeleton.value = false;
};

const checkDocuments = () => {
  if (totalDocuments.value < 1) {
    showMessage.value = true;
  }
};

const fetchDocuments = async () => {
  showDocumentSkeleton.value = true;
  const { id, community, division } = store.getters.selectedHome;
  const response = await getDocumentsData({
    divisionId: division.id,
    communityId: community.id,
    homeId: id,
    page: page.value,
    pageSize: totalRecords.value,
  });
  if (response) {
    totalDocuments.value = response.totalDocuments;
    response.reqDocuments.forEach((doc: Document) => {
      documents.value.push(doc);
    });
  }
  showDocumentSkeleton.value = false;
};

const fetchNewRecords = () => {
  page.value += 1;
  fetchDocuments();
};

onMounted(async () => {
  await fetchDocuments();
  checkDocuments();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (showMessage.value && !showDocumentSkeleton.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(noDocumentsMessage)), 1))
      : _createCommentVNode("", true),
    (!viewPoint.value && !showMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(DocumentsList, {
            documents: documents.value,
            totalDocuments: totalDocuments.value,
            showDocumentSkeleton: showDocumentSkeleton.value,
            onViewFile: view,
            onDownload: download,
            onFetchNewRecords: fetchNewRecords
          }, null, 8, ["documents", "totalDocuments", "showDocumentSkeleton"])
        ]))
      : _createCommentVNode("", true),
    (viewPoint.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(DocumentView, {
            showViewSkeleton: showViewSkeleton.value,
            document: document.value,
            documentPDF: documentPDFUrl.value,
            onDownload: _cache[0] || (_cache[0] = ($event: any) => (download(document.value))),
            onBack: _cache[1] || (_cache[1] = ($event: any) => (viewPoint.value=false))
          }, null, 8, ["showViewSkeleton", "document", "documentPDF"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})